export default {
  useMockApi: process.env.VUE_APP_USE_MOCK_API === 'false',
};
